<div class="modal-header">
    <h4 class="modal-title">ACH Payment</h4>
</div>
<div class="modal-body" (keyup.esc)="close()" (keyup.enter)="save()">
    <dx-form [formData]="ach"  validationGroup="achValidationGroup" >
        <dxi-item dataField="transactionDate" [label]="{ text: 'Date' }" editorType="dxDateBox">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <!-- <dxi-item dataField="transactionNumber" [label]="{ text: 'ACH #' }">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item> -->
        <!-- <dxi-item dataField="amount" [label]="{ text: 'Amount' }" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 2 }, step:0 }">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
            <dxi-validation-rule type="custom" [validationCallback]="amountMatchesOrder" message="ACH Amount does not match Order Total"> </dxi-validation-rule>
        </dxi-item> -->
        <dxi-item [label]="{ text: 'Notes' }">
            <div *dxTemplate>
                <dx-text-area [(value)]="ach.notes" [height]="100"> </dx-text-area>
            </div>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="save()">Save</button>
    <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
</div>
